import Header from "./components/Header";
import InputForm from "./components/InputForm";
import "./styles/css/main.css";
import { useState } from "react";

function App() {
    const [resultA, setResultA] = useState<number>(0);
    const [resultB, setResultB] = useState<number>(0);

    return (
        <div className="home">
            <Header />
            <InputForm title="Первый предмет" setResult={setResultA} />
            <InputForm title="Второй предмет" setResult={setResultB} />
            <div className="home__results">
                <h3>
                    {resultA
                        ? `Объём 1 предмета ≈ ${resultA} м³`
                        : `Объём 1 предмета: неизвестен`}
                </h3>
                <h3>
                    {resultB
                        ? `Объём 2 предмета ≈ ${resultB} м³`
                        : `Объём 2 предмета: неизвестен`}
                </h3>
                <p style={{ color: "red", fontSize: "24px" }}>
                    {Number.isNaN(resultA) || Number.isNaN(resultB)
                        ? "заполните все поля"
                        : null}
                </p>
                <p style={{ fontSize: "25px", marginTop: "50px" }}>
                    {(resultA / resultB < 1)
                        ? "Второй предмет должен быть меньше первого"
                        : `В предмет 1 поместится предмета 2 ≈ ${
                              resultA / resultB
                          } штук`}
                </p>
            </div>
        </div>
    );
}

export default App;
